import React from 'react';

interface SettingsIconProps {
  size?: number;
}

const SettingsIcon: React.FC<SettingsIconProps> = ({ 
  size = 24,
  ...props 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 204.18758 191.4059"
      version="1.1"
      id="svg8"
    >
      <defs id="defs2">
        <linearGradient id="linearGradient1035">
          <stop
            style={{ stopColor: "#c6cdd0", stopOpacity: 1 }}
            offset="0"
            id="stop1031"
          />
          <stop
            style={{ stopColor: "#f8fafb", stopOpacity: 1 }}
            offset="1"
            id="stop1033"
          />
        </linearGradient>
        <linearGradient id="linearGradient1027">
          <stop
            style={{ stopColor: "#0967b6", stopOpacity: 1 }}
            offset="0"
            id="stop1023"
          />
          <stop
            style={{ stopColor: "#0f4d8f", stopOpacity: 1 }}
            offset="1"
            id="stop1025"
          />
        </linearGradient>
        <linearGradient id="linearGradient1009">
          <stop
            style={{ stopColor: "#818a92", stopOpacity: 1 }}
            offset="0"
            id="stop1005"
          />
          <stop
            style={{ stopColor: "#65717b", stopOpacity: 1 }}
            offset="1"
            id="stop1007"
          />
        </linearGradient>
        <linearGradient
          xlinkHref="#linearGradient1009"
          id="linearGradient1011"
          x1="523.25903"
          y1="396.98996"
          x2="523.25903"
          y2="1078.8429"
          gradientUnits="userSpaceOnUse"
        />
        <linearGradient
          xlinkHref="#linearGradient1027"
          id="linearGradient1029"
          x1="66.798416"
          y1="317.88858"
          x2="119.18324"
          y2="367.86798"
          gradientUnits="userSpaceOnUse"
        />
        <linearGradient
          xlinkHref="#linearGradient1035"
          id="linearGradient1037"
          x1="90.852669"
          y1="296.77429"
          x2="90.852669"
          y2="390.58588"
          gradientUnits="userSpaceOnUse"
        />
      </defs>
      <g id="layer1" transform="translate(7.4994383,-247.26579)">
        <path
          id="path1002"
          style={{
            fill: "url(#linearGradient1011)",
            fillRule: "evenodd",
          }}
          d="m 895.63749,348.35117 c -36.14454,-2.71975 -16.12219,57.67342 -124.22067,74.13675 -93.53871,-0.86736 -97.83817,-52.80203 -119.3883,-69.07933 -14.71,-11.1108 -45.28026,2.75447 -86.96797,27.90391 -38.39755,23.9073 -49.4755,36.85235 -50.96048,46.98228 -2.46373,16.80653 15.26719,24.25958 18.79005,55.23163 1.8859,16.58034 6.18601,39.90077 -13.34986,75.00446 -22.67112,40.73736 -42.06832,49.10293 -59.34347,57.24955 -53.70448,25.32595 -75.45327,-42.35446 -82.63624,102.40122 -6.2648,126.25215 26.52928,54.20356 82.52272,80.98122 15.07939,7.21139 35.12044,12.22134 52.60423,41.43089 98.3805,164.36085 -98.07932,104.52107 62.86133,208.40235 105.45081,66.3384 88.34114,-53.20079 173.57617,-55.81641 191.53092,-3.01958 41.47601,137.19971 211.91016,49.76171 31.15156,-13.8092 47.84794,-30.7472 54.46194,-41.912 5.6865,-9.59918 3.6568,-13.21842 -0.01,-26.67815 -7.8168,-28.72513 -27.75221,-72.71352 -8.4307,-106.60985 93.1504,-155.68283 131.9812,30.01826 141.4747,-161.66913 -0.7235,-38.415 -2.0828,-63.46444 -11.7041,-73.11482 -9.9565,-9.98656 -28.4742,-3.98376 -46.9677,-9.5524 -16.6211,-5.00482 -47.6741,-11.64702 -61.808,-35.20116 -98.28874,-165.27834 85.7412,-132.15609 -77.50852,-212.94608 -33.70398,-16.67962 -44.5852,-26.12978 -54.90939,-26.90664 z"
          transform="matrix(0.26458333,0,0,0.26458333,-107.19405,155.12143)"
        />
        <g id="g1041">
          <path
            style={{
              fill: "url(#linearGradient1037)",
              fillRule: "evenodd",
            }}
            d="m 95.589844,292.04297 c -27.725647,0 -50.554688,22.82904 -50.554688,50.55469 0,27.72564 22.829041,50.55468 50.554688,50.55468 27.725646,0 50.554686,-22.82904 50.554686,-50.55468 0,-27.72565 -22.82904,-50.55469 -50.554686,-50.55469 z m 0,32.88476 c 9.953816,0 17.669926,7.71611 17.669926,17.66993 0,9.95381 -7.71611,17.66992 -17.669926,17.66992 -9.953815,0 -17.669922,-7.71611 -17.669922,-17.66992 0,-9.95382 7.716107,-17.66993 17.669922,-17.66993 z"
            id="path1019"
          />
          <path
            style={{
              fill: "url(#linearGradient1029)",
              fillRule: "evenodd",
            }}
            d="m 129.70252,342.5976 c 0,18.83973 -15.27262,34.11235 -34.112348,34.11235 -18.839731,0 -34.112351,-15.27262 -34.112351,-34.11235 0,-18.83974 15.27262,-34.11236 34.112351,-34.11236 18.839728,0 34.112348,15.27262 34.112348,34.11236 z"
            id="path1017"
          />
        </g>
      </g>
    </svg>
  );
};

export default SettingsIcon;